import {UpdateStoreServiceApiPayload} from "../../../../react-query-hooks/store/services/update-store-service/types";
import {EditStoreServiceFormValues} from "../types";
import {toStoreServicePricingPayload} from "../../create-service/create-store-service-service";
import {toPurchaseLimitUpdatePayload} from "../../../../components/offering-form/general/settings/purchase-limit-payload";

export function editStoreServiceDto(
  values: EditStoreServiceFormValues
): UpdateStoreServiceApiPayload {
  const redirectType =
    values.redirectAfterPurchase === "custom-url"
      ? "url"
      : values.redirectAfterPurchase ?? "none";

  return {
    ...toStoreServicePricingPayload(values),
    description: values.description,
    name: values.name,
    request_phone_number: values.requestCustomerPhoneNumber,
    ...toPurchaseLimitUpdatePayload(values),
    url_redirect: redirectType === "url" ? values.url_redirect : null,
    redirect_type: redirectType,
    telegram_group_chat_id:
      redirectType === "telegram" ? values.telegramGroupId ?? null : null,
    serviceId: values.id,
    delivery_timeframe_unit: values.deliveryTimeFrameUnit,
    delivery_timeframe_value: values.deliveryTimeFrameValue,
    hideFromProfile: values.hideFromProfile,
    bookingQuestions:
      values.bookingQuestions.length > 0
        ? values.bookingQuestions.map((q) => {
            if (
              q.answerType === "checkbox" ||
              q.answerType === "dropdown" ||
              q.answerType === "radio-button"
            ) {
              return {
                question: q.question,
                required: q.required,
                answer_type: q.answerType,
                options: q.options.map((o) => o.optionLabel),
              };
            } else {
              return {
                question: q.question,
                required: q.required,
                answer_type: q.answerType,
              };
            }
          })
        : [],
  };
}
